import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0559b896"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "header header-main",
  role: "banner"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-xl-2 col-lg-3 col-sm-4 col-5" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"col-xl-6 col-lg-5\" data-v-0559b896><div class=\"group-dropdown\" data-v-0559b896><ul class=\"dropdown-main\" data-v-0559b896><li data-v-0559b896><a href=\"https://toosim.com/#how-it-works\" data-v-0559b896>TooSim App</a></li><li data-v-0559b896><a href=\"https://toosim.com/esim-compatible\" data-v-0559b896>Compatibility</a></li><li data-v-0559b896><a href=\"https://toosim.com/esim-price\" data-v-0559b896>Price</a></li><li data-v-0559b896><a href=\"https://toosim.com/blog\" data-v-0559b896>Blog</a></li><li data-v-0559b896><a href=\"#\" class=\"btn btn-b btn-danger\" data-v-0559b896><i class=\"icon app-d\" data-v-0559b896></i>Buy an eSIM </a></li></ul></div></div>", 1)
const _hoisted_6 = { class: "col-xl-4 col-lg-4 col-sm-8 col-7 flex-nowrap" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon app-d" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "header__user-wrapper"
}
const _hoisted_9 = {
  key: 0,
  class: "header__cashback"
}
const _hoisted_10 = {
  key: 0,
  class: "header__user-menu"
}
const _hoisted_11 = { class: "header__user-menu--item disabled" }

import { useUserStore } from "@/stores/user";
import ProfileIcon from "@/components/icons/ProfileIcon.vue";
import { detectMobile } from "@/helpers";
import { computed, ComputedRef, ref, Ref } from "vue";
import router from "@/router";
import { useBundleStore } from "@/stores/bundle";
import { useAppStore } from "@/stores/app";
import PopupAuth from "@/components/popups/PopupAuth.vue";
import CoinIcon from "@/components/icons/CoinIcon.vue";
import { useDataStore } from "@/stores/data";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainHeader',
  setup(__props) {

const userStore = useUserStore();
const appStore = useAppStore();
const bundleStore = useBundleStore();
const dataStore = useDataStore();
const isMobile: boolean = detectMobile();

const menuOpened: Ref<boolean> = ref(false);

const openProfileMenu = (): void => {
  menuOpened.value = true;
};
const closeProfileMenu = (): void => {
  menuOpened.value = false;
};
const goProfile = (): void => {
  closeProfileMenu();
  router.push("/profile");
};
const goSupport = (): void => {
  closeProfileMenu();
  router.push("/support");
};
const logout = (): void => {
  closeProfileMenu();
  userStore.logout();
};

const goSearch = (): void => {
  bundleStore.clearBundles();
  router.push("/");
};

const goAuth = () => {
  router.push(`/${router.currentRoute.value.name}#auth`);
};

const currentRoutePath: ComputedRef<string> = computed(
  () => router.currentRoute.value.path
);
const userEmailTrimmed: ComputedRef<string> = computed(
  () => userStore.email.split("@")[0]
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "logo",
            to: "https://toosim.com"
          })
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-b btn-danger header__buy",
            onClick: goSearch
          }, [
            _hoisted_7,
            _createTextVNode("Buy an eSIM ")
          ]),
          (_unref(userStore).isAuth)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_unref(dataStore).cashbackEnabled && _unref(userStore).cashback > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(CoinIcon, { class: "header__cashback-icon" }),
                      _createTextVNode(" $" + _toDisplayString((_unref(userStore).cashback / 100).toLocaleString("en-US")), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn btn-b btn-default btn-primary align-items-center justify-content-center header__user",
                  onClick: openProfileMenu,
                  style: {"height":"48px","width":"48px","min-width":"48px","margin-left":"10px"}
                }, [
                  _createVNode(ProfileIcon, { style: {"min-width":"24px"} })
                ]),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (menuOpened.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("button", _hoisted_11, _toDisplayString(userEmailTrimmed.value), 1),
                          _createElementVNode("button", {
                            class: _normalizeClass(["header__user-menu--item", { active: currentRoutePath.value === '/profile' }]),
                            onClick: goProfile
                          }, " Show my eSIM ", 2),
                          _createElementVNode("button", {
                            class: _normalizeClass(["header__user-menu--item", { active: currentRoutePath.value === '/support' }]),
                            onClick: goSupport
                          }, " Support ", 2),
                          _createElementVNode("button", {
                            class: "header__user-menu--item",
                            onClick: logout
                          }, " Log out ")
                        ])), [
                          [_directive_click_outside, closeProfileMenu]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-b btn-default header__user",
                onClick: goAuth,
                style: {"margin-left":"10px"}
              }, " Log in "))
        ])
      ])
    ])
  ]))
}
}

})